// extracted by mini-css-extract-plugin
export default {"base":"vp_N7yeF","content":"vp_dFXIE","handle":"vp_eAOV7","flip":"vp_iZuSV","overlay":"vp_d6RSa","visible":"vp_f0i_D","slideOut":"vp_qMLiV","slide-out":"vp_cwVvr"};